<template>
  <!-- 精准客户配置 -->
  <section class="viewContainer">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao" />
      </div>
      <!-- 顶部搜索框 -->
      <el-form class="findform">
        <el-form-item style="display:flex;width:30%" label="所属城市：">
          <el-cascader v-model="chengshi" placeholder="请选择城市" :options="options" style="width:90%" filterable
            @change="handleChange" ref="cityAll" />
        </el-form-item>
        <el-form-item style="display:flex;width:30%;" label="店铺类型：">
          <el-select v-model="shopType" filterable placeholder="请选择" style="width:90%" @change="shopTypeFun">
            <el-option v-for="(item, index) in shopTypeArr" :key="index" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit" v-if="shopType!=1">查询</el-button> </el-form-item>
      </el-form>
      <el-form class="findform" v-if="shopType==1">
        <el-form-item style="display:flex;width:30%;" label="商品分类：">
          <el-select v-model="shopTypeId" style="display:flex;width:90%;" placeholder="请选择"
            @visible-change="choiceShoptype" @change="shopchangeFun">
            <el-option v-for="(item, index) in shopTypelist" :key="index" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item style="display:flex;width:30%;" label="品牌分类：" v-if="shopTypeId>0">
          <el-select v-model="BrandTypeId" style="display:flex;width:90%;" placeholder="请选择"
            @visible-change="choiceBrandtype">
            <el-option v-for="(item, index) in brandTypelist" :key="index" :label="item.brandtypename"
              :value="item.brandtypeid" />
          </el-select>
        </el-form-item>
        <el-form-item style="display:flex;width:30%;" label="品牌列表：" v-if="BrandTypeId>0">
          <el-select v-model="BrandId" style="width:90%;" placeholder="请选择" @visible-change="choiceBrand">
            <el-option v-for="(item, index) in brandListarr" :key="index" :label="item.brandname"
              :value="item.brandid" />
          </el-select>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
    </div>
    <!-- 列表 -->
    <div class="main_container">
      <div style="width: 98%;display: flex;justify-content: space-between;text-align: center;margin: 0 auto;">
        <p></p>
      </div>
      <div class="grid-container">
        <div v-for="(item, index) in inputList" :key="'item-' + item.cluetypeid + '-' + index" class="grid-item">
          <label :for="item.cluetypeid" class="labelClass">{{ item.cluetypename }}</label>
          <el-input :id="item.cluetypeid" v-model="item.price" maxlength="5" :style="{ marginLeft: '-2px' }"
            onkeyup="value=value.replace(/[^\d]/g,'');" /> <span style="line-height: 40px;margin-left: 10px;">元</span>
        </div>
      </div>
      <!-- 操作按钮 -->
      <!-- 权限: 城市合伙人=1 判断 scid 大于 0 隐藏按钮 -->
      <div style="width: 100%; text-align: center;margin: 10px 0 20px 0;" v-show="iscityadmin == 0 || scid < 0">
        <!-- <el-button @click="resetForm()">重置</el-button> -->
        <el-button type="danger" @click="addgoodcolunm()">保存</el-button>
      </div>
    </div>
  </section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { provincegetcountys, goodstypegetlist, brandtypegetlist, brandgetlist  } from '../../api/newOss';
import { getdetails, configsave } from "../../api/comment";
export default {
  name: "PrecisionCustomerConfig",//精准客户配置
  mixins: [alertTrends],
  data() {
    return {
      chengshi: [0], // 所在城市
      options: [],
      provinceId: 0, // 省
      cityId: 0, // 市
      countyId: 0, // 区县
      nameOfProvince: '', // 省名称
      cityName: '', // 市名称
      countyName: '', // 区县名称

      inputList: [
        { cluetypeid: 1, cluetypename: '冻结金额', price: '' },
        { cluetypeid: 2, cluetypename: '客单价', price: '' },
      ],

      isadmin: localStorage.isadmin, // 是否是超级管理员 0=否 1=是
      isplatformadmin: localStorage.isplatformadmin, // 是否是平台(全国)管理员 0=否 1=是
      iscityadmin: localStorage.iscityadmin, // 是否是城市管理员(城市分公司) 0=否 1=是
      scid: localStorage.scid, // 区县id


      shopTypeArr: [
        {
          Id: 2,
          Name: "装修公司"
        },
        {
          Id: 1,
          Name: "品牌建材"
        },
      ],
      shopType: 2,  //店铺类型

      shopTypelist: [
        {
          id: 0,
          name: "全部"
        }
      ],
      brandTypelist: [
        {
          brandtypeid: 0,
          brandtypename: "全部"
        }
      ],
      brandListarr: [
        {
          brandid: 0,
          brandname: "全部"
        }
      ],
      shopTypeId: '',
      BrandTypeId: '',
      BrandId: '',
      
    };
  },
  methods: {

    // 获取店铺类型
    onSubmit() {
      this.init();
    },
    shopTypeFun(){
      this.shopTypeId = 0;
      this.BrandTypeId = 0;
      this.BrandId = 0;
    },
    choiceShoptype(val) {
      if (val) {
        this.shopTypeId = 0;
        this.BrandTypeId = 0;
        this.BrandId = 0;
        
        this.letterDia2();
      }
    },
    //商品分类
    letterDia2() {
      goodstypegetlist().then(data => {
        if (data.resultCode == 1) {
          // this.shopTypelist = data.resultObj;
          // data.resultObj.unshift({
          //   id: 0,
          //   name: "全部"
          // });

          const resultObj = data.resultObj || []; // 兜底空数组
          this.shopTypelist = [{ id: 0, name: "全部" }, ...resultObj]; // 用解构替代unshift
        }

        
      });
    },
    shopchangeFun(val) {
      if(val){
        this.letterDia1();
      }
    },

    choiceBrandtype(val) {
      if (val) {
        this.BrandTypeId = 0;
        
        // this.letterDia1();
      }
    },

    // 品牌分类
    letterDia1() {
      var obj = {
        goodsTypeId: this.shopTypeId||0
      };
      brandtypegetlist(obj).then(data => {
        if (data.resultCode == 1) {
          // this.brandTypelist = data.resultObj;
          // data.resultObj.unshift({
          //   brandtypeid: 0,
          //   brandtypename: "全部"
          // });

          const resultObj = data.resultObj || []; // 兜底空数组
          this.brandTypelist = [{ brandtypeid: 0, brandtypename: "全部" }, ...resultObj]; // 用解构替代unshift
        }
      });
    },

    changeShop(item) {
      
      for (var i = 0; i < this.brandTypelist.length; i++) {
        if (this.brandTypelist[i].Id == item) {
          this.branName = this.brandTypelist[i].Name;
        }
      }
    },
    changeBrand(item) {
      for (var i = 0; i < this.brandTypelist.length; i++) {
        if (this.brandTypelist[i].Id == item) {
          this.branName = this.brandTypelist[i].Name;
        }
      }
    },

    async choiceBrand(val) {
      if (val) {
        this.BrandId = 0;
        
        await this.letterDia();
      }
    },

    // 获取品类品牌
    async letterDia() {
      var obj = {
        brandTypeId: this.BrandTypeId||0
      };
      await brandgetlist(obj).then(data => {
        if (data.resultCode == 1) {
          this.brandList = data.resultObj;
          data.resultObj.unshift({
            brandid: 0,
            brandname: "全部"
          });
          this.brandListarr = data.resultObj;
        }
      });
    },

    changeBra(item) {
      for (var i = 0; i < this.brandList.length; i++) {
        if (this.brandList[i].Id == item) {
          this.branName1 = this.brandList[i].Name;
        }
      }
    },

    init() {
      var obj = {
        configType: this.shopType, // 店铺类型
        provinceId: this.provinceId,
        cityId: this.cityId, // 城市ID
        countyId: this.countyId, // 区县ID 目前未开放区县配置 传0
        brandTypeId: this.BrandTypeId,
        brandId: Number(this.BrandId)||0,
      }
      getdetails(obj).then(data => {
        if (data.resultCode == 1) {
          this.inputList[0].price = data.resultObj.prepaidPrice;
          this.inputList[1].price = data.resultObj.details[0].price;
        } else {
          this.inputList[0].price = '';
          this.inputList[1].price = '';
        }
      })
    },
    // 重置
    fnReset() {
      this.provinceId = 0; // 省
      this.cityId = 0; // 市
      this.countyId = 0; // 区县
      this.chengshi = [0]
      this.shopType = 2;
      this.shopTypeId = 0;
      this.BrandTypeId = 0;
      this.BrandId = 0;
      this.init();
    },
    // 保存
    addgoodcolunm() {
      // if (this.shopType==1&&this.shopTypeId == '') {
      //   this.showAlert('请选择商品分类');
      //   return false;
      // }
      if (this.inputList[0].price == '') {
        this.showAlert('请输入冻结金额');
        return false;
      }
      if (this.inputList[1].price == '') {
        this.showAlert('请输入客单价');
        return false;
      }
      let BrandTypeId = this.shopType == 2?0:this.BrandTypeId;
      if (this.shopType == 1 && this.shopTypeId != 0 && this.BrandTypeId == 0){
        BrandTypeId = this.brandTypelist.slice(1).map(item => item.brandtypeid).join(',');
      }
      this.$swal({
        type: 'warning',
        text: '是否保存？',
        showCancelButton: true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then(res => {
        if (res.value) {
          var obj = {
            configType: this.shopType,
            provinceId: this.provinceId, // 省份ID
            cityId: this.cityId, // 城市ID
            countyId: this.countyId, // 区县ID 目前未开放区县配置 传0
            prepaidPrice: Number(this.inputList[0].price),
            details:[
              {
                brandTypeId: BrandTypeId,
                brandId: this.shopType == 2 ? 0 : this.BrandId,
                price: this.inputList[1].price
              }
            ]
          }
          configsave(obj).then(data => {
            if (data.resultCode == 1) {
              this.showAlert('保存成功', 'success');
              this.init();
            }
          })
        }
      })
    },
    // 请选择省市区/县
    handleChange(val) {
      this.provinceId = val[0]; // 省
      this.cityId = val[1]; // 市
      this.countyId = val[2]; // 区县
      let labels = this.$refs['cityAll'].getCheckedNodes()[0].pathLabels;
      this.nameOfProvince = labels[0];
      this.cityName = labels[1];
      this.countyName = labels[2];
    },
    // 查找省市区/县
    getprovince() {
      var loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        const provinceOptions = [];
        data.resultObj.forEach(item => {
          const province = { value: item.pid, label: item.pname, children: [] };
          if (item.citys && item.citys.length > 0) {
            item.citys.forEach(city => {
              const allCityOption = { value: 0, label: "全市" };
              let cityObj;
              if (city.countys && city.countys.length > 0) {
                cityObj = {
                  value: city.cid, label: city.cname,
                  children: [allCityOption].concat(city.countys.map(zone => ({
                    value: zone.scid, label: zone.scname
                  })))
                };
              } else {
                cityObj = { value: city.cid, label: city.cname, children: [allCityOption] };
              }
              province.children.push(cityObj);
            });
          } else { delete province.children; }
          provinceOptions.push(province);
        });
        this.options = provinceOptions;
        if (this.isadmin == 1 || this.isplatformadmin == 1) {
          this.options.unshift({ value: 0, label: "全国" });
        }
      })
    },
  },
  mounted() {
    this.getprovince();
    this.init();
  },
};
</script>
<style scoped>
.labelClass {
  width: 150px;
  height: auto;
  background: #909399;
  color: #fff;
  display: block;
  text-align: center;
  line-height: 40px;
  z-index: 1;
  border-radius: 4px 0 0 4px;
}

.grid-container {
  width: 98%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* 分为4列，每列等宽 */
  gap: 20px;
  /* 项目之间的间隔 */
  padding-bottom: 20px;
}

.grid-item {
  /* 可根据需要调整盒子样式 */
  display: flex;
  width: 80%;
}
</style>


// WEBPACK FOOTER //
// PrecisionCustomer.vue?6a3dc756